import type { ResourcesConfig } from 'aws-amplify';

// Environment-based configuration
// In dev, these can be overridden via env vars for local testing
const stage = import.meta.env.VITE_STAGE || (import.meta.env.PROD ? 'prod' : 'dev');

const userPoolId = import.meta.env.VITE_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;

// Validate required configuration at startup
if (!userPoolId || userPoolId.includes('PLACEHOLDER')) {
  throw new Error(
    'Missing VITE_USER_POOL_ID environment variable. ' +
      'Set it in .env.local for development or ensure CI/CD provides it.'
  );
}
if (!userPoolClientId || userPoolClientId.includes('PLACEHOLDER')) {
  throw new Error(
    'Missing VITE_USER_POOL_CLIENT_ID environment variable. ' +
      'Set it in .env.local for development or ensure CI/CD provides it.'
  );
}

const currentConfig = { userPoolId, userPoolClientId };

// Log configuration for debugging (non-sensitive info only)
if (import.meta.env.DEV) {
  console.log(`[Amplify] Stage: ${stage}, UserPoolId: ${userPoolId.split('_')[0]}...`);
}

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: currentConfig.userPoolId,
      userPoolClientId: currentConfig.userPoolClientId,
    },
  },
};
